import { combineReducers, configureStore } from '@reduxjs/toolkit'
import FilterReducer from './reducer/filter.reducer'
import UserReducer from './reducer/user.reducer'
import LoadingReducer from './reducer/loading.reducer'

const rootReducer = combineReducers({
    filters: FilterReducer,
    user: UserReducer,
    loading: LoadingReducer,
})

const store = configureStore({
    reducer: rootReducer,
})

export default store

export type RootState = ReturnType<typeof store.getState>
export type AppDispatch = typeof store.dispatch